import React from "react";

import { useQuery } from "@apollo/client";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

// import { DatePicker } from "@material-ui/pickers";

import moment from "moment";

import panelStatisticsMetaQuery from "./panel-statistics-meta-query";
import PanelStatisticsTableContainer from "./panel-statistics-table-container";
import TrendGraphContainer from "./trend-graph-container";

import { monthVar, yearVar } from "../../reactive-variables";
import { useReactiveQueryParam } from "../../use-reactive-query-params";

interface Props {
  nodes?: any[];
  panelCollectionName: string;
  // panelId?: string;
  // panelName: String;
  panelDefinition: any;
  // startDate: number; // Date;
  // endDate: number; // Date;
  // widgetStatic?: boolean;
  // widgetTitle?: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dateSelect: {
      cursor: "pointer",
    },
  })
);

function PanelStatisticsContainer(props: Props) {
  const {
    nodes,
    panelCollectionName,
    // panelId,
    panelDefinition,
    // startDate,
    // endDate,
    // widgetStatic,
    // widgetTitle,
  } = props;
  const classes = useStyles(props);
  // const [date, changeDate] = useState<Date | null>(new Date());
  const monthReactiveVar = useReactiveQueryParam("month", monthVar);
  const yearReactiveVar = useReactiveQueryParam("year", yearVar);
  const n = nodes ? nodes.join(",") : undefined;
  const { data, error, loading } = useQuery(panelStatisticsMetaQuery, {
    variables: {
      panelName: panelDefinition?.template,
      panelCollectionName: panelCollectionName,
      tab: panelDefinition?.id,
      node: n,
      month: monthReactiveVar(),
      year: yearReactiveVar(),
      // view: "statistic",
    },
  });
  // console.log("iconLink data", data);
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error.message);
    return <div>Error! {error.message}</div>;
  }
  // console.log("statistics meta", data);

  return (
    <Grid container>
      {/* <DatePicker
        autoOk
        views={["year", "month"]}
        // orientation="landscape"
        variant="static"
        openTo="year"
        minDate={new Date(`${data.statisticsMeta.minYear}-${data.statisticsMeta.minMonth}-01`)}
        maxDate={new Date(`${data.statisticsMeta.maxYear}-${data.statisticsMeta.maxMonth}-01`)}
        value={date}
        onChange={changeDate}
      /> */}
      <Grid container item xs={12} spacing={1} justify="space-evenly">
        {data.statisticsMeta.availableYears.map((year: number) => (
          <Typography
            key={year}
            variant="h5"
            className={classes.dateSelect}
            onClick={() => {
              yearReactiveVar(`${year}`);
            }}
            style={{
              fontWeight: `${year}` === yearReactiveVar() ? "bold" : undefined,
            }}
          >
            {year}
          </Typography>
        ))}
      </Grid>
      <Grid container item xs={12} spacing={1} justify="space-evenly">
        {data.statisticsMeta.availableMonths.map((month: any) => (
          <Typography
            key={month.number}
            variant="h6"
            className={classes.dateSelect}
            onClick={() => {
              monthReactiveVar(`${month.number}`);
            }}
            style={{
              fontWeight:
                `${month.number}` === monthReactiveVar() ? "bold" : undefined,
            }}
          >
            {month.string}
          </Typography>
        ))}
        <Typography
          key={"y"}
          variant="h6"
          className={classes.dateSelect}
          onClick={() => {
            monthReactiveVar(`y`);
          }}
          style={{
            fontWeight: `y` === monthReactiveVar() ? "bold" : undefined,
          }}
        >
          Year
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <PanelStatisticsTableContainer
          nodes={nodes}
          panelCollectionName={panelCollectionName}
          panelDefinition={panelDefinition}
          year={data.statisticsMeta.year}
          month={data.statisticsMeta.month}
        />
      </Grid>
      <Grid item xs={12}>
        <TrendGraphContainer
          nodes={nodes}
          panelCollectionName={panelCollectionName}
          panelName={panelDefinition?.template}
          panelDefinition={panelDefinition}
          startDate={
            moment(
              `${data.statisticsMeta.year}-${
                data.statisticsMeta.month === "y"
                  ? "01"
                  : data.statisticsMeta.month
              }-01`
            )
              .startOf("month")
              .unix() * 1000
          }
          endDate={
            moment(
              `${data.statisticsMeta.year}-${
                data.statisticsMeta.month === "y"
                  ? "01"
                  : data.statisticsMeta.month
              }-01`
            )
              .endOf(data.statisticsMeta.month === "y" ? "year" : "month")
              .unix() * 1000
          }
        />
      </Grid>
    </Grid>
  );
}

export default PanelStatisticsContainer;
